export default __webpack_public_path__ + "static/media/Precipitacao.b646594b.svg";